import { useEffect, useState } from "react";
import { HiMenu, HiX } from "react-icons/hi";
import { Link } from "react-router-dom";


export default function Header() {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [pathname, setPathname] = useState(window.location.pathname);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 0);
        };
        window.addEventListener("scroll", handleScroll);

        const handlePathChange = () => {
            setPathname(window.location.pathname);
        };
        window.addEventListener("popstate", handlePathChange);

        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("popstate", handlePathChange);
        };
    }, []);

    const navLinks = [
        { href: "/", label: "Home" },
        { href: "/estoque", label: "Estoque" },
        { href: "/financiamento", label: "Financiamento" },
        { href: "/venda", label: "Venda" },
        { href: "/contato", label: "Contato" },
    ];

    return (
        <header
            className={`sticky top-0 left-0 z-50 w-full bg-white shadow transition-colors duration-300 ${scrolled ? "scrolled" : ""}`}
        >
            <div className="mx-auto flex w-full max-w-7xl flex-col items-center px-4 py-3 sm:px-6">
                <a href="/" className="block" aria-label="Página inicial - Veículos Novos">
                    <img
                        src="/logo.png"
                        alt="Veículos Novos"
                        width={280}
                        height={140}
                        className="h-auto w-52 sm:w-60 md:w-72"
                    />
                </a>

                <div className="mt-2 flex w-full items-center justify-between md:hidden">
                    <span className="text-sm font-semibold text-black">Menu</span>
                    <button
                        onClick={() => setMenuOpen(!menuOpen)}
                        className="rounded p-1 text-3xl text-black transition-colors duration-300 hover:text-red-700 focus:outline-none focus:ring-2 focus:ring-red-700"
                        aria-label={menuOpen ? "Fechar menu" : "Abrir menu"}
                        aria-expanded={menuOpen}
                    >
                        {menuOpen ? <HiX /> : <HiMenu />}
                    </button>
                </div>

                <div className="mt-3 hidden w-full items-center justify-center gap-8 border-t border-gray-200 pt-3 md:flex">
                    <nav aria-label="Navegação principal">
                    <ul className="flex items-center gap-6 font-semibold text-black lg:gap-9">
                        {navLinks.map((link) => (
                            <li key={link.href}>
                                <a
                                    href={link.href}
                                    className={`relative pb-1 transition-colors ${pathname === link.href
                                        ? "after:content-[''] after:absolute after:left-0 after:right-0 after:-bottom-0.5 after:h-1 after:bg-red-600 after:rounded"
                                        : ""
                                        }`}
                                >
                                    {link.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                    </nav>

                    <div>
                    <Link to="/contato" className="bg-red-700 hover:bg-red-800 text-white px-4 py-2 rounded inline-block font-semibold transition-colors duration-300">
                        Fale Conosco
                    </Link>
                    </div>
                </div>
            </div>

            {menuOpen && (
                <nav className="border-t border-gray-200 bg-white shadow-md md:hidden" aria-label="Navegação móvel">
                    <ul className="mx-auto flex max-w-7xl flex-col items-stretch gap-1 px-6 py-4 text-black font-semibold">
                        {navLinks.map((link) => (
                            <li key={link.href}>
                                <a
                                    href={link.href}
                                    onClick={() => setMenuOpen(false)}
                                    className={`block w-full border-b border-gray-100 py-2 ${pathname === link.href ? "text-red-700" : ""
                                        }`}
                                >
                                    {link.label}
                                </a>
                            </li>
                        ))}
                        <li className="pt-3">
                            <Link
                                to="/contato"
                                onClick={() => setMenuOpen(false)}
                                className="block rounded bg-red-700 px-4 py-2 text-center text-white transition-colors hover:bg-red-800"
                            >
                                Fale Conosco
                            </Link>
                        </li>
                    </ul>
                </nav>
            )}
        </header>
    );
}
